module.exports = {"idea":"Do you have an app idea?","noNeed":"You don't need a tech co-founder and a million dollar seed round to make it come to life.","withUs":"At Get It Built, we build web and mobile apps for business owners that need quality software developed, not engineers on payroll."}


//////////////////
// WEBPACK FOOTER
// ./src/assets/copy/intake.json
// module id = 481
// module chunks = 0